import React, { useEffect } from 'react';

function ThankYou() {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://cdn.jsdelivr.net/particles.js/2.0.0/particles.min.js';
    script.async = true;
    document.body.appendChild(script);

    script.onload = () => {
      window.particlesJS('particles-js', {
        particles: {
          number: { value: 120, density: { enable: true, value_area: 1299.3805191013182 } },
          color: { value: ["#5D47BA", "#FFDBFF", "#FB5435", "#E00A30", "#04CEF9"] },
          opacity: { value: 1, random: false, anim: { enable: false, speed: 1, opacity_min: 0.1, sync: false } },
          size: { value: 18, random: true, anim: { enable: false, speed: 90, size_min: 0.1, sync: false } },
          move: { enable: true, speed: 9, direction: "top", random: false, straight: false, out_mode: "out", bounce: false, attract: { enable: false, rotateX: 600, rotateY: 1200 } }
        },
        interactivity: {
          detect_on: "canvas",
          events: {
            onhover: { enable: true, mode: "repulse" },
            onclick: { enable: true, mode: "push" },
            resize: true
          },
          modes: {
            repulse: { distance: 200, duration: 0.4 },
            push: { particles_nb: 4 }
          }
        }
      });
    };

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div className="App">
      <div id="particles-js"></div>
      <div className="thank-you-container">
        <div className="thank-you-box">
          <h1 className='fw-bold'>Thank You!</h1>
          <p className="lead">for reaching us!</p>
          <p >Kindly check your email for more details!</p>
        </div>
        <a className="return-black" href="https://www.peregrinee.com/" target="_blank" rel="noopener noreferrer">
          Back to Home
        </a>
      </div>
      <style jsx>{`
        html, body {
          height: 100%;
          margin: 0;
          padding: 0;
        }
        body {
          background: linear-gradient(to right,rgba(236, 72, 154, 0.5),rgba(239, 68, 68, 0.4),rgba(138, 92, 246, 0.5));
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          font-family: 'Helvetica', sans-serif;
          font-size: 16px;
        }
        h1 {
          font-size: 2.5rem;
          color:rgb(255, 255, 255);
        }
        #particles-js {
          position: fixed;
          top: 0;
          left: 0;
          height: 100%;
          width: 100%;
          z-index: -1;
        }
        .thank-you-container {
          margin: 0 auto;
          max-width: 500px;
          padding: 0 4em;
          z-index: 1;
        }
        .thank-you-box {
          background: linear-gradient(to right, #f97316, #dc2626, #7e22ce);
          color:rgb(255, 255, 255);
          padding: 1em 0.5em;
          border-radius: 5px;
          text-align: center;
        }
        .return-black {
          margin: 20px 0;
          text-align: center;
          width: 100%;
          float: left;
          font-weight: 600;
          color: White;
          text-decoration: none;
        }
      `}</style>
    </div>
  );
}

export default ThankYou;
